webpackJsonp([7],{

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = horizontalScrollMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_defaults__);


function horizontalScrollMenu(targetElement, options) {
  options = options || {};
  __WEBPACK_IMPORTED_MODULE_1_lodash_defaults___default()(options, {
    //selectedClassName: 'selected'
    fixed: true,
    scrollMenu: '.js-scroll-menu',
    scrollItem: '.scroll-menu__item',
    scrollItemActive: 'scroll-menu__item--active',
    scrollMenuFixed: 'scroll-menu--fixed',
    speed: 200
  }); //Apply active class for styling (mobile)

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.scrollItem).on("click", function () {
    var thisItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    thisItem.siblings().removeClass(options.scrollItemActive).end().addClass(options.scrollItemActive);
  }); //Fix Designer Menu header on scroll

  var fixedMenu = function fixedMenu() {
    if (options.fixed) {
      var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.scrollMenu);
      var elementHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).outerHeight(true);
      var scrollPosY = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop();
      var elementOffset = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).offset().top + elementHeight;
      var distance = elementOffset - scrollPosY;

      if (scrollPosY > distance) {
        element.addClass(options.scrollMenuFixed);
      } else {
        element.removeClass(options.scrollMenuFixed);
      }
    }
  }; //Adjust anchor scroll based on fixed header


  var adjustAnchor = function adjustAnchor() {
    var $anchor = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(':target');
    var element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(options.scrollMenu);
    var elementHeight = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).outerHeight(true);

    if ($anchor.length > 0) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('html, body').stop().animate({
        scrollTop: $anchor.offset().top - elementHeight
      }, options.speed);
      console.log('hit');
    }
  };

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('scroll resize', fixedMenu);
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).on('hashchange load', adjustAnchor);
} //End horizontalScrollMenu

/***/ }),

/***/ 307:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__plp_plp_lazy_load__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__horizontal_scroll_menu__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modules_heart_product__ = __webpack_require__(7);





function bindHeartItems() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_modules_heart_product__["a" /* default */])('#pageItems', '.fav-item');
}

function initHorizontalScrollmenu() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__horizontal_scroll_menu__["a" /* default */])();
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(document).ready(function () {
  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-designers-lazy-load').plpLazyLoad({
    sessionName: 'designerSessionData',
    loadAfterCallback: function loadAfterCallback() {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-designers-lazy-img').lazy({
        bind: "event",
        threshold: 1500
      });
    }
  });

  if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-scroll-menu').length) {
    initHorizontalScrollmenu();
  }

  __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-favorite-designer').on('click', function () {
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).toggleClass('favorite-button--heart-active');
  });
  bindHeartItems();
});

/***/ })

},[307]);


// WEBPACK FOOTER //
// dist/designers.js